// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import getAccessDeniedMessage from './getAccessDeniedMessage';

type Options = {
    action: string
};

const useAccessDeniedMessage = ({ action }: Options): string => {
    const { t } = useTranslation();
    const message = React.useMemo(() => {
        return getAccessDeniedMessage({ t, action });
    }, [t, action]);
    return message;
};

export default useAccessDeniedMessage;
